<div class="dev-server" *ngIf="_devMode">
  <span>version: {{ version }}</span>
  <span>Development</span>
</div>
<app-header></app-header>
<router-outlet></router-outlet>
<app-control-bar></app-control-bar>
